export const set = (state, data) => {
  state.records = data;
};

export const create = (state, data) => {
  state.records.push(data);
};

export const setSingleRecord = (state, data) => {
  const recordIndex = state.records.findIndex(record => record.id === data.id);
  if (recordIndex > -1) {
    state.records[recordIndex] = data;
  } else {
    create(state, data);
  }
};

export const update = (state, data) => {
  state.records.forEach((element, index) => {
    if (element.id === data.id) {
      state.records[index] = data;
    }
  });
};

/* when you don't want to overwrite the whole object */
export const updateAttributes = (state, data) => {
  state.records.forEach((element, index) => {
    if (element.id === data.id) {
      state.records[index] = { ...state.records[index], ...data };
    }
  });
};

export const updatePresence = (state, data) => {
  state.records.forEach((element, index) => {
    const availabilityStatus = data[element.id];
    state.records[index].availability_status = availabilityStatus || 'offline';
  });
};

export const updatePresenceReasons = (state, data) => {
  state.records.forEach((element, index) => {
    const reason = data[element.id];
    if (state.records[index].availability_status === 'busy') {
      const hadReason = state.records[index].availability_status_reason;
      state.records[index].availability_status_reason = reason || null;
      if (reason !== hadReason) {
        state.records[index].availability_updated_at = reason
          ? new Date().toISOString()
          : null;
      }
    } else {
      state.records[index].availability_status_reason = null;
      state.records[index].availability_updated_at = null;
    }
  });
};

export const updateSingleRecordPresence = (
  records,
  { id, availabilityStatus }
) => {
  const [selectedRecord] = records.filter(record => record.id === Number(id));
  if (selectedRecord) {
    selectedRecord.availability_status = availabilityStatus;
  }
};

export const destroy = (state, id) => {
  state.records = state.records.filter(record => record.id !== id);
};
